export default __webpack_public_path__ + "static/media/P945_CoC.0bde01a0.pdf";